import axiosInstance from 'ns_libs/nsAxios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';

interface MarkInvestmentMemoViewedRequest {
    organizationId: string;
    dealId: number;
    proFormaId: number;
    investmentMemoId: number;
}

const markInvestmentMemoViewed = async ({
    organizationId,
    dealId,
    proFormaId,
    investmentMemoId,
}: MarkInvestmentMemoViewedRequest): Promise<void> => {
    const baseUrl = API_ENDPOINTS.INVESTMENT_MEMO.MARK_VIEWED(dealId, proFormaId);
    const endpoint = `${baseUrl}?organizationId=${organizationId}&investment_memo_id=${investmentMemoId}`;
    await axiosInstance.patch(endpoint);
};

const useMarkInvestmentMemoViewed = ({
    organizationId,
    dealId,
    proFormaId,
    investmentMemoId,
}: MarkInvestmentMemoViewedRequest) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => markInvestmentMemoViewed({
            organizationId,
            dealId,
            proFormaId,
            investmentMemoId,
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['latestInvestmentMemo', organizationId, dealId, proFormaId],
            });
        },
    });
};

export default useMarkInvestmentMemoViewed;
